module.exports = __webpack_public_path__ + "img/latest-news.31cc6cdd.svg";